import React, { useState } from 'react';

interface PaymentModalProps {
  isOpen: boolean;
  onClose: () => void;
  packageType: 'starter' | 'basic' | 'pro';
  onPaymentComplete: (purchaseId: string) => void;
}

const PACKAGES = {
  starter: { tokens: 10, price: 29999, emoji: '⭐' },
  basic: { tokens: 50, price: 139999, emoji: '⭐⭐' },
  pro: { tokens: 100, price: 259999, emoji: '⭐⭐⭐' },
};

export function PaymentModal({
  isOpen,
  onClose,
  packageType,
  onPaymentComplete,
}: PaymentModalProps) {
  const [paymentMethod, setPaymentMethod] = useState<'momo' | 'bank'>('momo');
  const [isProcessing, setIsProcessing] = useState(false);
  const pkg = PACKAGES[packageType];

  if (!isOpen) return null;

  const handlePayment = async () => {
    setIsProcessing(true);

    setTimeout(() => {
      const purchaseId = 'purchase-' + Date.now();

      alert(`✅ Thanh toán thành công!\n\nBạn đã mua ${pkg.tokens}M tokens\n\nPurchase ID: ${purchaseId}\n\nGửi purchase ID này cho admin để nhận tokens!`);

      onPaymentComplete(purchaseId);
      onClose();
      setIsProcessing(false);
    }, 2000);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-8 max-w-md w-full mx-4">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-bold">Thanh toán</h2>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700 text-2xl">
            ×
          </button>
        </div>

        <div className="bg-gray-50 p-4 rounded-lg mb-6">
          <div className="flex justify-between mb-2">
            <span className="text-gray-600">{pkg.emoji} {packageType.toUpperCase()}</span>
            <span className="font-semibold">{pkg.tokens}M tokens</span>
          </div>
          <div className="border-t pt-2 flex justify-between">
            <span className="font-medium">Tổng cộng:</span>
            <span className="text-2xl font-bold text-blue-600">{pkg.price.toLocaleString()}đ</span>
          </div>
        </div>

        <div className="mb-6">
          <label className="block text-sm font-medium mb-3">Chọn phương thức thanh toán</label>
          <div className="space-y-2">
            <button
              onClick={() => setPaymentMethod('momo')}
              className={`w-full p-3 border rounded-lg text-left transition ${
                paymentMethod === 'momo'
                  ? 'border-blue-600 bg-blue-50'
                  : 'border-gray-300'
              }`}
            >
              <div className="font-medium">💳 MoMo (Mobile Wallet)</div>
              <div className="text-sm text-gray-600">Quét mã QR hoặc nhập số điện thoại</div>
            </button>

            <button
              onClick={() => setPaymentMethod('bank')}
              className={`w-full p-3 border rounded-lg text-left transition ${
                paymentMethod === 'bank'
                  ? 'border-blue-600 bg-blue-50'
                  : 'border-gray-300'
              }`}
            >
              <div className="font-medium">🏦 Chuyển khoản ngân hàng</div>
              <div className="text-sm text-gray-600">Chuyển tiền vào tài khoản</div>
            </button>
          </div>
        </div>

        {paymentMethod === 'momo' && (
          <div className="bg-blue-50 p-4 rounded-lg mb-6">
            <div className="text-sm font-medium mb-2">Liên hệ Admin MoMo:</div>
            <div className="bg-white p-3 rounded text-center">
              <div className="text-lg font-bold">Liên hệ: 0987654321</div>
              <div className="text-xs text-gray-600 mt-2">Nội dung chuyển khoản: {packageType.toUpperCase()}</div>
            </div>
          </div>
        )}

        {paymentMethod === 'bank' && (
          <div className="bg-blue-50 p-4 rounded-lg mb-6 text-sm space-y-1">
            <div>
              <span className="font-medium">Ngân hàng:</span> VIB
            </div>
            <div>
              <span className="font-medium">STK:</span> 1234567890
            </div>
            <div>
              <span className="font-medium">Chủ TK:</span> CLAUDE VIETNAM
            </div>
            <div>
              <span className="font-medium">Nội dung:</span> {packageType.toUpperCase()}-{Date.now()}
            </div>
          </div>
        )}

        <button
          onClick={handlePayment}
          disabled={isProcessing}
          className="w-full bg-blue-600 hover:bg-blue-700 disabled:bg-gray-400 text-white font-medium py-3 rounded-lg transition"
        >
          {isProcessing ? '⏳ Đang xử lý...' : '✅ Xác nhận thanh toán'}
        </button>

        <p className="text-center text-xs text-gray-500 mt-4">
          Sau khi thanh toán, liên hệ admin để nhận tokens.
        </p>
      </div>
    </div>
  );
}
